module.exports = __webpack_public_path__ + "static/media/Slide1.73db11fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/Slide1.png
// module id = 570
// module chunks = 4